module.exports = __webpack_public_path__ + "static/media/dawn_lake.61454542.jpg";